module.exports = __webpack_public_path__ + "static/media/eventmain.adc21d4f.png";